import React from 'react';

/**
 * Footer Component
 */
const Footer = () => (
   <footer className="footer-main">
      <p className="footer-main__copy">Copyright © {(new Date().getFullYear())}</p>
   </footer>
);

export default Footer;